module.exports = __webpack_public_path__ + "static/media/InfinityPic.f77bc76e.png";